import firebase from 'firebase'
import { useCollection } from 'react-firebase-hooks/firestore'

const options = {
    snapshotListenOptions: {
        includeMetadataChanges: true,
    },
}

const useCounters = () => {
    const db = firebase.firestore()

    const countersRef = db.collection('counters')

    const [counters, loading, error] = useCollection(countersRef, options)

    const data = !error && !loading && counters != null && !counters.empty ? counters.docs[0].data() : null

    return [error, loading, data]
}

export default useCounters
